import React, { useState } from "react";

const Seller = () => {
  const [followStatus, setFollowStatus] = useState(
    Array.from({ length: 8 }).fill(false)
  );

  const handleFollow = (index) => {
    setFollowStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = !newStatus[index];
      return newStatus;
    });
  };

  return (
    <div className="w-[951px] h-[787px] mt-[18px] py-[4px] flex flex-col gap-y-[16px] rounded-[10px] overflow-y-scroll items-center">
      {Array.from({ length: 8 }).map((_, index) => (
        <>
          <div className="w-[945px] h-[214px] bg-white rounded-[10px] p-[19px] flex flex-row drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <img
              src={require("../../../assets/allProducts/Suppliers.jpg")}
              alt=""
              className="w-[232px] h-[175px] rounded-[5px]"
            />
            <div className="flex flex-col ml-[20px] justify-center">
              <div className="flex flex-row gap-x-[10px] h-[30px] items-center justify-center">
                <img
                  src={require("../../../assets/allProducts/Suppliers/image 214.jpg")}
                  alt=""
                  className="w-[52px] h-[30px]"
                />
                <h3 className="w-[218px] h-[22px] font-semibold text-[16px] text-black text-start">
                  ABC Manufactures Pvt. Ltd.
                </h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-4 h-4 text-[#FF6300]"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <img
                  src={require("../../../assets/allProducts/Suppliers/Trusted.jpg")}
                  alt=""
                  className="w-[71px] h-[22px]"
                />
              </div>
              <p className="w-[408px] h-[52px] text-start text-black font-medium text-[12px] mt-[19px] leading-[26px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua lorem{" "}
              </p>
              <div className="flex flex-row gap-x-[13px] items-center justify-start mt-[25px]">
                <button className="w-[132px] h-[37px] flex flex-row font-semibold text-[12px] gap-x-[8px] items-center justify-center bg-[#FF6300] rounded-[5px]">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.54102 15.5837C3.15143 15.5837 2.81793 15.4449 2.54049 15.1675C2.26306 14.8901 2.12435 14.5566 2.12435 14.167V6.18053C1.91185 6.05067 1.74067 5.88244 1.61081 5.67585C1.48095 5.46925 1.41602 5.23019 1.41602 4.95866V2.83366C1.41602 2.44408 1.55473 2.11057 1.83216 1.83314C2.10959 1.55571 2.4431 1.41699 2.83268 1.41699H14.166C14.5556 1.41699 14.8891 1.55571 15.1665 1.83314C15.444 2.11057 15.5827 2.44408 15.5827 2.83366V4.95866C15.5827 5.23019 15.5178 5.46925 15.3879 5.67585C15.258 5.88244 15.0868 6.05067 14.8743 6.18053V14.167C14.8743 14.5566 14.7356 14.8901 14.4582 15.1675C14.1808 15.4449 13.8473 15.5837 13.4577 15.5837H3.54102ZM3.54102 6.37533V14.167H13.4577V6.37533H3.54102ZM2.83268 4.95866H14.166V2.83366H2.83268V4.95866ZM6.37435 9.91699H10.6243V8.50033H6.37435V9.91699Z"
                      fill="white"
                    />
                  </svg>
                  <p className="w-[87px] h-[18px] text-white">View Products</p>
                </button>
                <button
                  className="w-[121px] h-[37px] bg-white border rounded-[5px] flex items-center justify-center font-semibold text-[12px] gap-x-[8px]"
                  onClick={() => handleFollow(index)}
                >
                  {followStatus[index] ? (
                    "Unfollow"
                  ) : (
                    <>
                      <svg
                        width="26"
                        height="23"
                        viewBox="0 0 26 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.568 12.118H21.74V15.016H20.256V12.118H17.428V10.774H20.256V7.876H21.74V10.774H24.568V12.118Z"
                          fill="black"
                        />
                        <g clip-path="url(#clip0_328_8706)">
                          <path
                            d="M6.66602 6.33333C6.66602 7.21739 7.0172 8.06523 7.64233 8.69036C8.26745 9.31548 9.11529 9.66667 9.99935 9.66667C10.8834 9.66667 11.7313 9.31548 12.3564 8.69036C12.9815 8.06523 13.3327 7.21739 13.3327 6.33333C13.3327 5.44928 12.9815 4.60143 12.3564 3.97631C11.7313 3.35119 10.8834 3 9.99935 3C9.11529 3 8.26745 3.35119 7.64233 3.97631C7.0172 4.60143 6.66602 5.44928 6.66602 6.33333Z"
                            stroke="black"
                            stroke-width="1.83333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5 18V16.3333C5 15.4493 5.35119 14.6014 5.97631 13.9763C6.60143 13.3512 7.44928 13 8.33333 13H11.6667C12.5507 13 13.3986 13.3512 14.0237 13.9763C14.6488 14.6014 15 15.4493 15 16.3333V18"
                            stroke="black"
                            stroke-width="1.83333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_328_8706">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p className="w-[39px] h-[18px] text-black">Follow</p>
                    </>
                  )}
                </button>
              </div>
            </div>

            <hr className="w-[1px] bg-[#D8D8D8] h-[178px] ml-[37px] flex flex-col items-center justify-between" />

            <div className="w-full h-full flex flex-col items-start justify-between pl-[23px]">
              <div className="gap-y-[6px] flex flex-col">
                <h3 className="w-[53px] h-[18px] font-semibold text-[12px]">
                  Location
                </h3>
                <p className="w-[178px] h-[18px] font-medium text-[12px]">
                  Mumbai , Maharashtra , India
                </p>
              </div>

              <div className="gap-y-[6px] flex flex-col">
                <h3 className="w-[58px] h-[18px] font-semibold text-[12px]">
                  Category
                </h3>
                <p className="w-[132px] h-[18px] font-medium text-[12px]">
                  Consumer Electronics
                </p>
              </div>

              <div className="gap-y-[6px] flex flex-col">
                <h3 className="w-[94px] h-[18px] font-semibold text-[12px]">
                  Supplier Rating
                </h3>
                <div className="flex flex-row gap-x-[7px]">
                  <svg
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.5 0L7.95934 4.49139H12.6819L8.86126 7.26722L10.3206 11.7586L6.5 8.98278L2.6794 11.7586L4.13874 7.26722L0.318133 4.49139H5.04066L6.5 0Z"
                      fill="#FED500"
                    />
                  </svg>
                  <p className="w-[35px] h-[18px] font-medium text-[12px] text-black">
                    4.1 / 5
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default Seller;
